// Cabinet/CalendarTab.tsx
import React from "react";
import CalendarApp from "../Employee/CalendarApp";

const CalendarTab: React.FC = () => {
    return (
        <div className="calendar-tab" style={{height: "85%", flex: 1}}>
            <CalendarApp
                initialAppState={{
                    initialView: "month",
                    initialWeekStart: new Date(),
                    initialUserType: "observer",
                    initialCanEdit: false,
                    initialAvailableViews: ["day", "week", "month"],
                    initialShowButtons: false,
                    initialDebugging: false,
                    initialTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    initialShowHorizontalLines: true,
                    initialShowVerticalLines: true,
                    initialShowLineToggles: false,
                    initialMaxDaysForSelection: 1,
                    initialShowOnlyEvents: true,
                }}
            />
        </div>
    );
};

export default CalendarTab;
